import React from "react"

const DGHR = () => {
    return <hr style={{ color: "rgba(0,0,0,0)", height: 1, boxShadow: "1px 1px rgba(10,10,10,0.4)" }} />
}

export default DGHR